// List of all application editable strings : 
// Automatically generated 2026-01-25T16:14:04.945Z
exports.strings = {  email_from_name:`APR-2SP ne pas repondre`,
  email_admin:`validation-ee@prevention-risquespro.fr`,
  email_from:`no-reply@prevention-risquespro.fr`,
  email_bcc:`edecadoudal@gmail.com`,
  email_admin_to:`apr-2sp46@orange.fr`,
  email_tech_to:`edecadoudal@gmail.com`,
  email_signature:`<p>Bien cordialement.<br>
  L'équipe APR 2SP<br>
  Carole DELBREIL<br>apr-2sp46@orange.fr<br>
  06 74 92 46 46</p>`,
  template_d4_engage:`<p><b>S’engage en outre, en tant que donneur d'ordre rattaché à l’Opération N° {{operation.code}}</b></p>
  <ul>
    <li>à informer ses personnels des consignes de Sécurité et Santé au Travail prises en commun, sous l'autorité du chef de l'Entreprise Utilisatrice et dans le respect de son obligation de Coordination Générale des mesures de Prévention de l'opération dont, celles liées à la spécificité des risques biologiques</li><li>à faire respecter le Plan de Prévention Évolutif de l’opération</li><li>à vérifier que chacun de ses personnels&nbsp; a eu son embauche validée par la DPAE</li><li>à s’assurer de la présence sur site d’un Sauveteur Secouriste au Travail</li><li>à obliger chacun de ses personnels au port des EPI conformes à son activité</li><li>à contrôler que ses sous-traitants se sont enregistrés et s'engagent à respecter les obligations ci-dessus</li>
  </ul>`,
  ppe_company_covid:`Responsable Administratif`,
  email_contact_ee_subject:`Compléments d'information`,
  B1_CompanyPageEEId_covidOfficer_name_label:`Responsable administratif`,
  "covidOfficer.name_label":`Responsable administratif`,
  ppe_access_walkers:`Accès piétons « visiteurs »`,
  ppe_access_vehicle:`Accès véhicules « livraison »`,
  ppe_access_permanentvehicle:`Accès véhicules « permanents »`,
  ppe_page4_desc:`<p><strong>L’Entreprise Utilisatrice doit établir par écrit un Plan de Prévention Evolutif, 
    à partir de son Plan de Prévention matriciel Evolutif, avant le commencement de l’opération (article R4512-7).
    </strong></p>
<table style="border-collapse: collapse; width: 100%;border: #800000 2px solid;" border="0"><tbody><tr><td style="padding: 6px;">
  « On entend par <b>opération</b> toutes les <b>Prestations</b>, <b>Interventions</b>, <b>Livraisons</b>, <b>Maintenance</b> ou <b>Tâches d’Amélioration</b>
    réalisées par une ou plusieurs entreprises afin de concourir à un même objectif. »  (Article CT R4511-4).
</td></tr></tbody></table>
<p>Dans son Plan de Prévention Evolutif, l’Entreprise Utilisatrice :</p>
<ul>
  <li>« Assure la coordination générale des mesures de prévention qu’elle prend, et de celles des Entreprises Extérieures intervenant dans son établissement. » (article R4511-5)</li>
  <li>« Communique aux Entreprises Extérieures ses consignes de sécurités applicables aux travailleurs chargés d’exécuter l’opération» (article R4512-4) dans le respect de leur devoir</li>
</ul>
<p>Les mesures de prévention que prennent les entreprises, par rapport à leurs risques propres identifiés, sont déjà inscrites dans leur Document Unique Evolutif  (D.U.E .) respectif, qu’elles mettent à jour une fois par an ou à l’occasion d’un évènement marquant.
</p>
<p>Conformément au décret n°2001-1016, chaque entreprise doit établir un D.U.Evolutif d’évaluation des risques professionnels de son établissement principal et de chacun de ses établissements secondaires.
  A partir du moment où une entreprise occupe sur un site extérieur des locaux qui lui sont dédiés de manière continue, 
  le site extérieur devient un établissement secondaire, avec obligation pour elle de faire un D.U. Evolutif spécifique 
  pour ce site. Chaque DU Evolutif doit faire état du «travail des personnels sur des sites extérieurs » 
  et mentionner les mesures de prévention préconisées.
</p>
<p>Chaque Entité juridique / entreprise est hébergée sur un Site, ce dernier peut être composé de plusieurs pôles</p>
<ul>
  <li><u>Chaque pôle</u> à l’intérieur du site, doit élaborer, pour gérer l’INTERACTIVITE, son DUE, 
    Document Unique Évolutif d’évaluation des risques professionnels générés par son activité et ses métiers, 
    à l’encontre de ses personnels</li>
  <li><u>Chaque pôle</u> à l’intérieur du site, est considéré comme une Entreprise Utilisatrice, 
    qui doit élaborer, pour gérer la COACTIVITE, son Plan de Prévention Évolutif pour 
    « matcher » les risques générés par des Entreprises Extérieures avec ceux déjà identifiés dans son DUE</li>
</ul>
<p>C’est le chef de l’Entreprise Utilisatrice qui organise et coordonne les différents travaux pendant le déroulement 
  de l’opération. Il est libre de déléguer cette mission à toute personne physique ayant les compétences nécessaires 
  et reconnues, ou à toute personne morale ou organisme habilité.</p>
<p>Les réunions et Visites d’Inspection Préalable se font à l’initiative de l’Entreprise Utilisatrice 
  avec informations de tous les partenaires sociaux internes, CSE ou externes, Médecine du Travail.
</p>
<p>Le suivi des interventions consiste à contrôler que les mesures décidées dans le cadre du Plan de Prévention Evolutif, 
  sont effectivement respectées et à décider de mesures nouvelles lorsque des changements interviennent 
  dans le déroulement de l’opération.
</p>
<table style="border-collapse: collapse; width: 100%;border: #800000 2px solid;" border="0">
  <tbody><tr><td style="padding: 6px;">&nbsp; &nbsp;En résumé, l’objectif est de compléter le « Plan de Prévention matriciel / Evolutif » de l’Entreprise Utilisatrice avec les risques
  des Entreprises Extérieures Prestataires pour le transformer en « Plan de Prévention Evolutif » mis à jour au fur et à mesure
  de l’arrivée des Entreprises Extérieures&nbsp; attributaires&nbsp; et des Entreprises Extérieures sous-traitantes, participant à l’opération.<br></td></tr></tbody></table>`,
  ppe_eu_definition:`L'Entreprise Utilisatrice est l'entité qui accueille des Entreprises Extérieures pour participer à une opération sur son site / pôle  en activité et qui assure la coordination générale des mesures de prévention qu'elle prend.`,
  ppe_page6_desc:`
<p><b>Les « devoirs qui s’imposent »</b> aux Entreprises Extérieures oeuvrant à l'intérieur d'un site / pôle en activité :<br>
</p><li>Ne pas encombrer les portes des issues de secours</li>
<li>Ne rien déposer dans les escaliers</li>
<li>Ne pas encombrer les couloirs</li>
<li>Ne pas gêner le fonctionnement des portes à fermeture automatique</li>
<li>Ne pas bloquer les portes avec des cales</li>
<li>Respecter les consignes de sécurité et les interdictions (fumer…)</li>
<li>Signaler toutes anomalies et problèmes rencontrés (électriques, fluides…)</li>
<li>Connaître les numéros de secours interne (PCS, référent technique)</li>
<li>Respecter les consignes de sécurité en cas de déclenchement d'un incendie</li>
<li>Récupérer les déchets après chaque journée de travail et les évacuer </li>
<p></p>`,
  template_d4_subtitle:`<br><b>valant "Visite d'Inspection Préalable"</b>`,
  template_d4_sign:`Le soussigné`,
  template_d4_items:`<li>des risques propres à l’Entreprise Utilisatrice {{operation.company.name}} identifiés dans son Plan de Prévention matriciel, transcrits dans son Livret d’Accueil Prévention : "Identification des dangers et des risques du site".</li><li>des risques générés par son intervention sur le site {{operation.sitename}} et ceux générés par les autres Entreprises Extérieures travaillant sur le site. <br>Ces risques sont reportés,&nbsp;au fur et à mesure de leur arrivée sur le site/ pôle de l'opération, dans le «Plan de Prévention Evolutif » à partir des informations qu'ils ont communiqués en renseignent leur «Livret d’Accueil Prévention »</li>`,
  ppe_home_help_subtitle:`Pour quoi faire ?`,
  template_d4_title:`D 4 . BORDEREAU D’ENGAGEMENT SST de l’Opération`,
  template_d4_presentation:`<b>A l’issue de la validation de son LAP Livret d’Accueil Prévention D3. par le Préventeur référent </b>:`,
  template_d4_phone:`Mobile`,
  template_d4_ee:`Représentant de l’Entreprise Extérieure`,
  template_d4_siret:`Ayant pour numéro de SIRET`,
  template_d4_address:`Dont le siège social est situé`,
  template_d4_reco:`Reconnaît par la présente avoir pris connaissance :`,
  ppe_cover:`<b>COUVERTURE</b>`,
  operation_title:`Opération`,
  operation_code:`PROJET N°`,
  ppe_page2:`<b>PAGE 2</b>`,
  ppe_matriciel_title:`PLAN de PREVENTION matriciel / Evolutif de l’E.U.`,
  ppe_page2_desc:`<p>Le plan de prévention Evolutif d'une opération à l'intérieur d'un site/pôle en activité 
  est en permanente évolution.</p>
<p>Il est élaboré à partir du Plan de Prévention matriciel / Evolutif de l'Entreprise Utilisatrice,
  complété avec les risques liés à l'Opération et avec les risques propres apportés par chacune
  des Entreprises Extérieures prestataires.</p>
<p>Le Plan de Prévention Evolutif se trouve donc calendairement mis à jour au fur et à mesure de l'arrivée 
  des Entreprises Extérieures sur le lieu de la prestation.</p>
<p>&nbsp;</p>`,
  ppe_presentation:`FICHE DE PRESENTATION DE L'ENTREPRISE UTILISATRICE`,
  ppe_company_name:`Nom`,
  ppe_company_address:`Adresse`,
  ppe_company_activity:`Activité`,
  ppe_company_activity2:`Activité 2`,
  ppe_company_phone:`Téléphone`,
  ppe_company_web:`Web`,
  ppe_company_siret:`SIRET`,
  ppe_company_pers:`Nombre de personnels`,
  ppe_company_owner:`Responsable de l'Entité Utilisatrice`,
  ppe_company_owner_phone:`Portable`,
  ppe_company_owner_email:`Mail`,
  ppe_company_security:`Responsable Sécurité`,
  ppe_company_security_phone:`Portable`,
  ppe_company_security_email:`Mail`,
  ppe_company_covid_phone:`Portable`,
  ppe_company_covid_email:`Mail`,
  ppe_company_operation:`Responsable des opérations`,
  ppe_company_operation_phone:`Portable`,
  ppe_company_operation_email:`Mail`,
  ppe_page3:`<b>PAGE 3</b>`,
  ppe_page3_subtitle:`Plan de Prévention Evolutif d’une opération élaboré à partir du Plan de Prévention matriciel
  d’une Entreprise Utilisatrice pour gérer l’Intervention d’Entreprises Extérieures à l’intérieur d’un site / pôle 
  en activité`,
  ppe_page3_desc:`<p>Le Code du travail prévoit un dispositif particulier en organisant les modalités d’interventions
  d’Entreprises Extérieures sur le site / dans les locaux d’une Entreprise Utilisatrice 
  (art. R4511 et suivants du Code du travail).<br />
  L’organisation de l’hygiène et de la sécurité lors de l’intervention d’Entreprises Extérieures est prévue 
  par le décret n°92-158 du 20 février 1992 (art. R4531-1 et suivants du Code du travail).<br />
  <strong>Ce décret vise à prévenir les risques résultants de l’interférence des activités 
    des Entreprises Extérieures et de l’Entreprise Utilisatrice.</strong>.&nbsp;
  </p>
<p>Il concerne toutes les Prestations, Livraisons, Interventions, Maintenance, Tâches d’amélioration.</p>
<p><strong>Son principe est de gérer l’interactivité et la coactivité des entreprises et de lier la responsabilité 
  de la sécurité au site/pôle où l’opération se déroule.</strong>.</p>
<p>La coordination générale des mesures de prévention mise en œuvre par chaque Entreprise Extérieure 
  est assurée par le chef de l’Entreprise Utilisatrice, chaque chef d’Entreprise Extérieure étant 
  responsable des mesures de prévention qui protège son propre personnel.
</p>
<p>Avant l’exécution de l’opération et sur le site/pôle de l’opération, les chefs d’entreprises procèdent à :</p>
<ul>
<li>une Visite d’Inspection Préalable des lieux de travail où se déroule l’Opération</li>
<li>une analyse des risques propres, importés, exportés par l’ensemble des entreprises</li>
<li>la mise en place d’un <b>Plan de Prévention Evolutif</b> élaboré par l’Entreprise Utilisatrice 
  à partir de son plan de Prévention matriciel, complété par les risques liés à l’Opération 
  et les risques générés par chaque Entreprise Extérieure</li>
</ul>
<p>Les réunions se font à l’initiative de l’Entreprise Utilisatrice, avec information à tous les 
  partenaires sociaux internes, CSE, ou externes, médecine du Travail.
</p>
<p class='callout'>
  Le Plan de Prévention Evolutif précise les mesures à prendre par chaque entreprise pour 
  supprimer ces risques, les diminuer ou les limiter à un niveau acceptable.
</p>
<p>
  <u>Un Plan de Prévention Évolutif, doit être élaboré avec toutes les EE œuvrant 
    sur une opération spécifique à l’intérieur d’un même pôle.</u>
  Il peut aussi être élaborer avec toutes les EE rassemblant tous les secteurs d’activité 
  d’un même pôle ou avec toutes les EE rassemblant un seul secteur d’activité d’un même pôle.
</p>
<p class='callout'><strong>
  Le chef de l’Entreprise Utilisatrice a une obligation générale de coordination et de 
  surveillance de l’Opération. Il doit alerter le chef de l’Entreprise Extérieure 
  s’il constate un risque ou un manquement aux obligations de sécurité, même si ce risque 
  n’est pas lié à l’interférence entre plusieurs activités.
</strong>
</p>
<p class='callout'>
  Le chef d’une Entreprise Extérieure est tenu quant à lui de rappeler au chef de 
  l’Entreprise Utilisatrice la coordination que celui-ci doit assurer, si par exemple 
  les « Visites d’Inspection  Préalable » des lieux de travail ne sont pas effectuées 
  ou si le « Plan de Prévention Evolutif » n’a pas été élaboré précisément pour l’opération 
  concernée et avant toute intervention, puis mis à jour au fur et à mesure de l’arrivée 
  de chaque Entreprise Extérieure
</p>`,
  ppe_page4:`<b>PAGE4</b>`,
  ppe_page4_subtitle:`Mode d’intégration des nouveaux risques identifiés, pour élaborer <br>
  le Plan de Prévention Evolutif de l’opération en milieu occupé`,
  ppe_page5:`<b>PAGE 5</b>`,
  ppe_page5_subtitle:`Présentation des dangers majeurs de l’Entreprise Utilisatrice (E.U.)`,
  ppe_page5_subtitle2:`(D’après les informations recueillies dans son Document Unique) `,
  ppe_eu_sod_electric:`ELECTRIQUE`,
  ppe_eu_sod_mecanic:`MECANIQUE`,
  ppe_eu_sod_chimic:`CHIMIQUE`,
  ppe_eu_sod_fire:`INCENDIE/EXPLOSION`,
  ppe_eu_sod_ionizingRadiation:`RAYONEMENTS IONISANTS`,
  ppe_eu_sod_nonIonizingRadiation:`RAYONEMENT NON IONISANTS`,
  ppe_eu_sod_handlingCirculation:`MANUTENTION CIRCULATION`,
  ppe_eu_sod_misc:`DIVERS`,
  ppe_workunits:`UNITES DE TRAVAIL INVENTORIEES DANS LE DOCUMENT UNIQUE EVOLUTIF`,
  ppe_page6:`<b>PAGE 6-7</b>`,
  ppe_page6_subtitle:`Identification des dangers et des risques du site`,
  ppe_risks_head_title:`DANGERS / RISQUES`,
  ppe_risks_head_causes:`CAUSES / CONSEQUENCES POTENTIELLES`,
  ppe_risks_head_prevention:`MESURES DE PRÉVENTION`,
  ppe_page8:`<b>PAGE 8</b>`,
  ppe_evolutive_title:`PLAN DE PREVENTION EVOLUTIF de l’Opération`,
  ppe_page8_desc:`<p><strong>Applicable aux opérations effectuées dans le site Entreprise Utilisatrice (EU), donnant 
  lieu à une interactivité avec plusieurs Entreprises Extérieures (EE), et à une coactivité entre les Entreprises 
Extérieures.</strong></p>`,
  operation_site:`Lieu de l'opération`,
  operation_type:`Type d'opération`,
  operation_name:`Designation du projet`,
  operation_description:`Description de l'opération`,
  operation_startdate:`Début de l’opération`,
  operation_companycountexpected:`Nombre d’entreprises programmées`,
  operation_companycount:`Nombre d’entreprises enregistrées`,
  operation_duration:`Durée programmée`,
  operation_workinghours:`Horaires de travail`,
  eu_title:`Entreprise Utilisatrice`,
  eu_name:`Raison sociale`,
  eu_address:`Adresse`,
  eu_companyowner:`Représentant qualifié`,
  eu_securityofficer:`Responsable S.S.T.`,
  operation_organization:`Organisation de l'opération`,
  operation_maincontractor:`Maître d’œuvre`,
  operation_projectmanager:`Responsable du projet`,
  operation_cspspreventer:`Préventeur / C.SPS`,
  ppe_page9:`<b>PAGE 9</b>`,
  ppe_rescue_title:`Organisation des secours`,
  ppe_rescue_groupingzone:`Zone de regroupement en cas d’évacuation`,
  ppe_rescue_onsitesupport:`Assistance et guidage sur site`,
  ppe_rescue_securityofficer:`Préventeur sécurité`,
  ppe_rescue_accidentprocedure:`Procédure en cas d'accident`,
  ppe_rescue_externalemergencyaccess:`Accès des secours extérieurs`,
  ppe_coviddangers_title:`Dangers et risques liés à la spécificité de l’environnement biologique`,
  ppe_page10:`<b>PAGE 10</b>`,
  ppe_access_title:`ACCES à l’Opération`,
  ppe_access_siteaccess:`>Cheminements pour accéder à l’Opération`,
  ppe_access_circulation:`Règles de circulation, accès piétons, véhicules, chargement/déchargement`,
  ppe_access_hours:`Site  accessible`,
  ppe_access_hours_desc:`Sur autorisation de 7h00 - 19h00`,
  ppe_access_walkers_desc:`-`,
  ppe_access_vehicle_desc:`-`,
  ppe_access_permanentvehicle_desc:`-`,
  ppe_access_drivers_note:`➨ Les chauffeurs des véhicules Utilitaires devront être en possession du Protocole de Sécurité (chargement/déchargement) établi selon le modèle validé par le chargé de Prévention SST du site.`,
  ppe_access_security_note:`➨ Les Agents de Sureté / Sécurité sont chargés de contrôler les personnels à chaque point d’entrée sur le site. Les personnels, n’ayant pas l’accréditation et n’étant pas sur les listes de demandes d’accès, ne pourront pas y pénétrer.`,
  ppe_page12:`<b>PAGE 12</b>`,
  ppe_page12_title:`OBLIGATIONS SECURITAIRES`,
  ppe_security_obligations:`
<p><b>Le permis feu</b></p>
<p>Il est obligatoire pour tous travaux par points chauds. Cette démarche s’intègre dans les procédures 
  existantes (Plan de Prévention, PPSPS, PPMS .. ) et fait partie intégrante des mesures de prévention 
  issues de l’évaluation des risques transcrite dans le Document Unique.
</p>
<p>Les travaux par points chauds regroupent :</p>
<ul>
  <li>Les opérations d’enlèvement de matière ou de démontage d’équipements (découpage, meulage, ébarbage…) </li>
  <li>Les opérations d’assemblage (soudures) ou d’étanchéité (bitume)</li>
  <li>Les opérations de production d'énergie avec un générateur à moteur thermique</li>
</ul>
<p>De manière générale, cette désignation comprend tous les travaux générateurs d’étincelles ou de surfaces chaudes. 
  Les machines portatives tournantes (disqueuses, tronçonneuses, perceuses) 
  sont autant impliquées dans l’accidentologie que les chalumeaux et les postes de soudage.</p>
<p>Le permis feu doit être formalisé et expliqué. Chaque intervenant doit connaître les risques 
  et les moyens à mettre en œuvre pour les diminuer. L’intervenant s’engage à respecter les règles préconisées. 
  Le permis feu est établi par le reponsable SST de l'Entreprise Utilisatrice ou son représentant, et autorise à l’exécution de travaux par points chauds 
  dans des conditions définies, qu’ils soient réalisés par le personnel de l’Entreprise Utilisatrice ou par celui d’une Entreprise Extérieure.</p>
<p><b>La consignation électrique</b></p>
<p>Elle permet d’effectuer des interventions hors tension électrique sur un ouvrage en exploitation.</p>
<p>Il faut effectuer les 4 opérations suivantes :</p>
<ul>
  <li><u>Séparation</u> de l’ouvrage des sources de tension électrique</li>
  <li><u>Condamnation</u> des organes de séparation en position d’ouverture et signalisation (pancarte d’interdiction de manœuvre)</li>
  <li><u>Identification</u> de l’ouvrage, afin de s’assurer que la zone de travail est bien située sur l’ouvrage mis hors tension</li>
  <li><u>Vérification</u> de l’absence de tension électrique, puis mise à la terre et en court-circuit.</li>
</ul>
<p><b>La consignation des fluides et de l’énergie mécanique</b></p>
<p>Elle permet d’effectuer des travaux ou des interventions hors tension hydraulique, mécanique sur un ouvrage en exploitation.</p>
<p>Il faut effectuer les 4 opérations suivantes :</p>
<ul>
  <li><u>Séparation</u> de l’installation ou de l’équipement de toute source de tension mécanique, suppression de l’arrivée des fluides, coupure de la transmission d’énergie, etc.</li>
  <li><u>Condamnation</u> de chaque organe en le verrouillant en position d’ouverture pour assurer la séparation. La consignation exige l’immobilisation de l’organe (blocage mécanique) et la signalisation par panneau « Organe condamné, ne pas manœuvrer. »</li>
  <li><u>Purge</u> des circuits pour s’assurer que la zone de travail est bien située sur l’ouvrage consigné (étude des schémas, des plans…).</li>
  <li><u>Vérification</u> de l’absence de tension sur chacun des conducteurs actifs de pression, d’énergie…</li>
</ul>`,
  ppe_page13:`<b>PAGE 13</b>`,
  ppe_page13_title:`Procédures de consignation à appliquer et autorisations particulières écrites à demander`,
  ppe_consignationprocedures:`Procédures de consignation`,
  ppe_consignationprocedures_note:`Seuls les personnels habilités peuvent effectuer une consignation`,
  ppe_specificauthorizations:`Autorisations particulières écrites, à faire valider par l'E.U. avant chaque intervention`,
  ppe_specialauthorisations:`Autorisations spéciales à produire`,
  ppe_specialauthorisations_note:`des EPI conformes et adaptés au poste de travail doivent être obligatoirement portés`,
  ppe_ponctualrisks:`Nouveaux risques liés à la spécificité de l’opération, générés par l’E.U`,
  ppe_ponctualrisks_none:`Aucun nouveau risque identifié dans l'EU`,
  ppe_page14:`<b>PAGE 14</b>`,
  ppe_newrisks_title:`Risques liés à la spécificité de l’Opération générés par les E.E.`,
  ppe_newrisks:`Liste des nouveaux risques apportés par une ou plusieurs Entreprises Extérieures`,
  ppe_page15:`<b>PAGE 15</b>`,
  ppe_listing_ee:`Bordereau chronologique d'émargement SST des Entreprises Extérieures`,
  ppe_listing_ee_rank:`N° ordre VIP`,
  ppe_listing_ee_name:`RAISON SOCIALE DE L’E.E.`,
  ppe_listing_ee_tasks:`TRAVAUX PREVUS`,
  ppe_listing_ee_owner:`REPRÉSENTANT Nom et Prénom <br />TEL- MAIL`,
  ppe_listing_ee_datesign:`DATE ET SIGNATURE`,
  D4_undefined_children_14:`<p><b>S’engage en outre, en tant que donneur d'ordre rattaché à l’Opération N° {{operation.code}}&nbsp;</b></p>
  <ul>
    <li>à informer ses personnels des consignes de Sécurité et Santé au Travail prises en commun, sous l'autorité du chef de l'Entreprise Utilisatrice et dans le respect de son obligation de Coordination Générale des mesures de Prévention de l'opération dont, celles liées à la spécificité des risques biologiques</li>
    <li>à faire respecter le Plan de Prévention Évolutif de l’opération</li>
    <li>à vérifier que chacun de ses personnels&nbsp; a son embauche validée par la DPAE</li>
    <li>à s’assurer de la présence sur site d’un Sauveteur Secouriste au Travail</li>
    <li>à obliger chacun de ses personnels au port des EPI conformes à son activité</li><li>à contrôler que ses sous-traitants et leurs personnels respectent&nbsp; les obligations&nbsp; ci-dessus</li>
  </ul>`,
  template_d1_title:`D1 . PROTOCOLE DE SECURITE`,
  template_d1_subtitle:`opérations de chargement et de déchargement (art R4515-1 à R4515-11 du Code du Travail Décret 92-158 du 20 02 1992 et arrêté du 26 04 96)`,
  template_d1_eu:`(E.U.) ENTREPRISE UTILISATRICE`,
  template_d1_eu_subtitle:`Entreprise d’Accueil`,
  template_d1_site:`Site :`,
  template_d1_adresse:`Adresse entrée :`,
  template_d1_resp_secu:`Responsable sécurité :`,
  template_d1_email:`Mail :`,
  template_d1_tel:`Tel :`,
  template_d1_prev_secu:`Préventeur sécurité :`,
  template_d1_ee:`(E.E.) ENTREPRISE EXTERIEURE`,
  template_d1_ee_subtitle:`Entreprise effectuant le transport de marchandises / matériel`,
  template_d1_company:`Raison Sociale :`,
  template_d1_company_adresse:`Adresse :`,
  template_d1_company_resp:`Responsable :`,
  template_d1_connaissances:`CONNAISSANCE des CARACTERISTIQUES TECHNIQUES du SITE`,
  template_d1_note_livraison:`* en fonction du lieu de livraison (déterminé par le demandeur)`,
  template_d1_zone_interdites:`zones interdites aux chauffeurs`,
  template_d1_moyens_manutentation:`MOYENS DE MANUTENTION`,
  template_d1_eq_fixe:`Equipement fixe dans l'Entreprise Utilisatrice`,
  template_d1_eq_mobile:`Equipement mobile disponible dans l'Entreprise Utilisatrice`,
  template_d1_eq_mobile_vehicule:`Equipement mobile sur véhicule E.E.`,
  template_d1_access_heures:`Accès au site autorisé de {{ operation.workingHours }} sur la continuité de l'année calendaire`,
  template_d1_risk_chargement:`RISQUES PARTICULIERS d'interférence`,
  template_d1_risk_interf:`Risques particuliers d’interférence`,
  template_d1_risk_measures:`MESURES DE PRÉVENTION`,
  template_d1_immatriculations:`IMMATRICULATIONS des VEHICULES de l’EE`,
  template_d1_vehicules_prives:`Véhicules Privés`,
  template_d1_vehicules_transp:`Véhicules Transport de Personnes`,
  template_d1_vehicules_util:`Véhicules Utilitaires Légers`,
  template_d1_vehicules_pl:`Véhicules Poids Lourds`,
  template_d1_marchandises:`NATURE et CONDITIONNEMENT des MARCHANDISES`,
  template_d1_marchandises_nature:`NATURE des marchandises`,
  template_d1_marchandises_etat:`ETAT des marchandises`,
  template_d1_marchandises_cond:`CONDITIONNEMENT des marchandises`,
  template_d1_consignes_produits:`CONSIGNES PARTICULIERES LIEES aux PRODUITS TRANSPORTES par EE`,
  template_d1_consignes_chargement:`Les opérations de chargement et de déchargement des <b>marchandises 
      et produits dangereux</b> sont des phases qui nécessitent une vigilance 
      particulière de tous les intervenants. Il faut donc suivre la réglementation 
      de l’ADR, relative au transport de matières dangereuses. Les contrats types 
      définis par marchandise transportée et /ou mode de transport utilisé, listent 
      les obligations incombant à l’expéditeur, au transporteur et au destinataire`,
  template_d1_donneur_ordre:`DONNEUR D’ORDRE RESPONSABLE de la MISSION TECHNIQUE :`,
  template_d1_donneur_ordre_entite:`ENTITE : `,
  template_d1_donneur_ordre_interlocuteur:`Interlocuteur : `,
  template_d1_urgences:`URGENCES`,
  template_d1_pc_secu:`Localisation du PC Sécurité  : `,
  template_d1_pc_secu_tel:`Tel PC Sécurité : `,
  template_d1_zone_regroup:`Zone de regroupement en cas d’évacuation : `,
  template_d1_defibrilateur:`Localisation défibrillateur : `,
  template_d1_samu_tel:`Tel SAMU        <b>15</b>`,
  template_d1_police_tel:`Tel POLICE 	<b>17</b>`,
  template_d1_pompier_tel:`Tel POMPIERS 	<b>18</b>`,
  template_d1_urgences_europ_tel:`Appel urgences européen :`,
  ppe_page11:`<b>PAGE 11 optionelle si plan</b>`,
  ppe_page11_title:`PLAN SECURITAIRE DU SITE`,
  template_d4_presenceof:`En présence de`,
  email_admin_ee_savedx_subject:`MODIFICATION de {{formName}} de {{ee.name}} sur l'operation {{operation.code}}`,
  email_admin_ee_savedx_html:`<p>L’Entreprise Extérieure {{ee.name}} a renseigné des documents SST ({{formName}})  sur l'opération {{operation.code}} {{operation.operationname}}.</p>  <p>Merci de contrôler ses documents</p>  <p><a href='https://ppe.prevention-risquespro.fr/ppe_ee/operation_home_ee/{{subscription.id}}'>Consulter</a></p>  <p></p><p>  Email automatique   </p>`,
  email_invite_subject:`Plan de Prévention Evolutif - Invitation à rejoindre l'opération {{code}}`,
  email_invite_html:`<p>Bonjour,</p>  <p>Cet email vous est envoyé par {{accountName}} pour vous permettre d'accéder à son site {{accountCompany}}</p>  <p>Vous êtes invité à rejoindre le Plan de Prévention Evolutif de l'opération {{code}} en cliquant sur un des liens ci-dessous</p>  <li>Vous avez déjà un compte sur le logiciel PPE : <a href="https://ppe.prevention-risquespro.fr/login/{{to}}">M'identifier</a></li>    <li>Vous pouvez créer un compte ici : <a href="https://ppe.prevention-risquespro.fr/register?redirectUrl=%2Flogin">Créer mon compte</a></li>  <p>Dans la rubrique S'inscrire sur une nouvelle opération, entrez le code :</p>  <p><b>{{code}}</b></p>  <p>Nous restons à votre disposition pour vous aider dans la démarche.</p>`,
  email_inviteoperation_to:`{{to}}`,
  email_invite_operation_resend_subject:`RAPPEL : OBLIGATION INTEGRATION PLAN DE PREVENTION - {{code}}`,
  email_forgotpassword_to:`{{email}}`,
  email_register_subject:`Plan de Prévention Evolutif - Confirmez votre inscription`,
  email_register_html:`<p>Bonjour {{name}},</p>  <p>Vous venez de vous inscrire sur le logiciel PPE,&nbsp; Plan de Prévention Evolutif</p>  <p>Votre identifiant est :{{email}}</p>  <p>Votre mot de passe temporaire :{{password}}</p>  <p>Veuillez vous connecter et choisir votre mot de passe</p>  <p><a href="https://ppe.prevention-risquespro.fr/login/{{email}}">Vous connecter sur PPE</a></p>  <p></p>`,
  email_forgotpassword_subject:`Plan de Prévention Evolutif - Changez votre mot de passe`,
  email_forgotpassword_html:`<p>Bonjour {{name}},</p>  <p>Cet email vous est envoyé pour réinitialiser votre mot de passe</p>  <p>Si ce n'est pas vous qui en avez fait la demande vous pouvez ignorer cet email</p>  <p>Cliquez sur le lien suivant pour choisir un nouveau mot de passe</p>  <p><a href='https://ppe.prevention-risquespro.fr/changepassword/{{_id}}'>Changez votre mot de passe</a></p>  <p></p>`,
  email_admin_ee_savecny_subject:`VALIDATION de l'EE {{ee.name}}`,
  email_admin_ee_savecny_html:`<p>L’Entreprise Extérieure {{ee.name}} a changé des informations dans sa fiche B1</p>  <p>Merci de contrôler ses documents</p>  <p><a href='https://ppe.prevention-risquespro.fr/ppe_ee/home/{{account._id}}'>Voir</a></p>  <p></p><p>  Email automatique   </p>`,
  email_invite_ee_subject:`Plan de Prévention Evolutif - Invitation à rejoindre l'opération {{code}}`,
  email_invite_ee_html:`<p>Bonjour,</p>  <p>Cet email vous est envoyé par {{accountName}} de la société {{accountCompany}} pour vous permettre d'accéder    au site {{sitename}} ,&nbsp; sur l'opération {{code}} {{operationname}} en cliquant sur un des liens ci-dessous</p>  <li>Vous avez déjà un compte sur PPE : <a href="https://ppe.prevention-risquespro.fr/login/{{to}}">M'identifier</a></li>    <li>Vous pouvez créer un compte ici : <a href="https://ppe.prevention-risquespro.fr/register?redirectUrl=%2Flogin">Créer mon compte</a></li>  <p>Dans la rubrique S'inscrire sur une nouvelle opération, entrez le code :</p>  <p><b>{{code}}</b></p>  <p>Nous restons à votre disposition pour vous aider dans la démarche.</p>`,
  operation_nonworkingdays:` - travail jours non ouvrés`,
  B1_CompanyPageEEId_name_label:`Nom de l'Entreprise`,
  ppe_listing_ee_none:`Aucune entreprise`,
  EU_C_Operation_company_label:`Société`,
  EU_C_Operation_sitename_label:`Site / Pole`,
}